import React from "react";
import { Link } from "react-router-dom";
import "./SuccessPage.css"; 

export default function SuccessPage() {
  return (
    <div className="success-page">
      <div className="success-card">
        <h1>🎉 Success!</h1>
        <p>Your login was successful. You can now view and register for events.</p>
        <Link to="/events" className="success-btn">Go to Events</Link>
      </div>
    </div>
  );
}
